import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { formatTransferLocaleDate } from "../utils";

interface FormattedLocaleDateProps {
    date: Date;
    locale?: string;
    className?: string; // will use a span if present
}

const FormattedLocaleDate: FunctionComponent<FormattedLocaleDateProps> = props => {
    const intl = useIntl();
    const date = formatTransferLocaleDate(props.date, props.locale || intl.locale);
    return props.className ? <span className={props.className}>{date}</span> : <>{date}</>;
};

export default FormattedLocaleDate;
